import ProductType from "../dtos/products/productType"
import { baseApi } from "./baseAPI"

export const productTypeAPI = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getProductTypes: build.query<ProductType[], void>({
            query: () => "producttype"
            ,
            // Cache for id
            providesTags: (_result, _error) => _result?.map(m => ({ type: "productType", value: m.code})) ?? []
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        }),
        putProductType: build.mutation<ProductType, ProductType>({
            query: (body) => ({
                url: `producttype`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (isUpdated) => {
                if (!isUpdated) {
                    return [];
                }
                return [{type: 'productType', value: isUpdated.code}]
            }
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetProductTypesQuery,
    usePutProductTypeMutation
} = productTypeAPI
